import { getStyle } from "../../hooks/use-styles";
import HexButton from "../../ui-kit/HexButtons";

import "./styles.css";

const EmptyListBox = ({
  imageSrc,
  title,
  subTitle,
  titleColor,
  footer,
  className,
  enableBtn = null,
}) => {
  return (
    <div
      className={`flex align-center justify-center empty-list-box ${
        className || ""
      }`}
    >
      <div className="empty-list-container text-center">
        {imageSrc && <img src={imageSrc} alt="placeholderImage" />}
        <p
          className="full-width empty-list-title"
          style={{ color: getStyle(titleColor || "black") }}
        >
          {title}
        </p>

        {subTitle && (
          <p
            className="text-base empty-list-description"
            style={{ color: getStyle("secondaryGray") }}
          >
            {subTitle}
          </p>
        )}
        {enableBtn && (
          <HexButton
            size={enableBtn.size || "lg"}
            type={enableBtn.type || "primary"}
            label={enableBtn.label || "Button"}
            icon={enableBtn.icon || null}
            onClick={() => enableBtn.onClick()}
            className="empty-list-action-button full-width"
          />
        )}
        {footer && (
          <div
            className="text-base empty-list-description empty-list-footer-text"
            style={{ color: getStyle("secondaryGray") }}
          >
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

export default EmptyListBox;
